<template>
  <div class="user-story-wrapper" ref="interest">
    <template v-if="!scoreEnd.defaults">
      <div class="relative overflow-hidden" ref="poster" @click="onPreview">
        <div class="poster-wrapper" ref="image">
          <img :src="bgImage.url" alt="" @load="onBgLoad" />
        </div>
        <div class="poster-content" v-if="bgLoad">
          <div class="poster-info" ref="info">
            <div v-if="scoreEnd.displayPicture && user" class="flex">
              <div class="user-avatar">
                <van-image
                    round
                    :width="40 * scale + 'px'"
                    :height="40 * scale + 'px'"
                    :src="user.weixinHeadimgurl"
                    @load="onAvatarLoad"
                />
              </div>
              <div class="ml-3 mb-1">
                <div ref="nickName" class="text-theme-black-850">
                  <span>{{ user.weixinNickName }}</span>
                </div>
                <div v-html="scoreEnd.richText" ref="welcome"></div>
              </div>
            </div>
          </div>
          <div class="poster-text-content" ref="textContent" v-if="scoreEnd.posterContent"
               v-html="scoreEnd.posterContent"></div>
          <div class="poster-user-list" ref="userList" v-if="scoreEnd.users && scoreEnd.users.length">
            <div v-for="(u,i) in scoreEnd.users" :key="i" class="poster-user-item">
              <div class="flex items-center">
                <van-image
                    round
                    :width="30 * scale + 'px'"
                    :height="30 * scale + 'px'"
                    :src="u.weixinHeadimgurl"
                    @load="onAvatarLoad"
                />
                <span class="ml-2">{{ u.weixinNickName }}</span>
              </div>
              <div class="user-content">
                {{ u.answerContent }}
              </div>
            </div>
            <div class="poster-user-item" v-if="scoreEnd.users.length ===1">
              <div class="flex items-center">
                <van-image
                    round
                    :width="30 * scale + 'px'"
                    :height="30 * scale + 'px'"
                    :src="avatar"
                    @load="onAvatarLoad"
                >
                </van-image>
              </div>
              <div class="yq-btn" @click.stop="onShare">
                邀请
              </div>
            </div>
          </div>
          <div class="poster-qrcode" ref="qrcode">
            <vue-qr :callback="onQrcodeLoad" :logo-src="logoSrc" :text="url" :margin="10" :size="600"
                    :logo-scale="0.15"></vue-qr>
          </div>
        </div>
        <div class="switch-btn" v-if="showSwitchBtn" @click.stop="onSwitchAnswer">
          切换
        </div>
      </div>
      <van-button type="primary" size="small" block v-if="genPosterUrlError" @click="onGenPoster"> 重新生成海报</van-button>
      <van-button type="primary" size="small" block v-else> 长按图片分享给好友</van-button>
    </template>
    <template v-else>
      <div v-html="scoreEnd.richText"></div>
    </template>
  </div>
</template>

<script>
import Interest from './Interest'
import html2canvas from 'html2canvas'
import { addLogStory, dataURLToBlob, upload } from 'dygc'
import WeixinShareTip from '../overlay/WeixinShareTip'
import { createPopup } from '../../assets/js/factory'

export default {
  name: 'UserStory',
  extends: Interest,
  data() {
    return {
      avatarCount: 1,
      avatarLoadCount: 0,
      showSwitchBtn: false,
      avatar: require('../../assets/img/avatar.png')
    }
  },
  methods: {
    onAvatarLoad() {
      this.avatarLoadCount++
      if (this.avatarLoadCount === this.avatarCount) {
        this.avatarLoad = true
        this.onGen()
      }
    },
    initUserStoryStyle() {
      const scoreEnd = this.scoreEnd
      if (scoreEnd.users && scoreEnd.users.length) {
        this.setStyle(this.$refs.userList, scoreEnd.usersInfo)
      }
      const textContent = this.$refs.textContent
      if(!textContent) return
      const scrollHeight = textContent.scrollHeight
      const clientHeight = textContent.clientHeight
      if(scrollHeight > clientHeight)  {
        const currentWidth =  parseInt(textContent.style.width)
        // TODO
        const scale = clientHeight / scrollHeight

        textContent.style.width = currentWidth / scale + 'px'
        textContent.style.transform = `scale(${scale})`
        textContent.style.transformOrigin = 'top left'
      }
    },
    onShare() {
      createPopup(WeixinShareTip)
    },
    onGenPoster() {
      if (this.$bus.scoreEnd.defaults) return
      this.$bus.closeLoading()
      this.$bus.openLoading('正在生成海报...')
      html2canvas(this.$refs.poster, {
        dpi: 120,
        useCORS: true,
        allowTaint: true
      })
          .then(canvas => {
            this.$bus.closeLoading()
            let s = canvas.toDataURL('image/png')
            this.genPosterUrlError = false
            this.posterUrl = s
            if (this.$bus.scoreEnd.nextAnswerId) {
              this.showSwitchBtn = true
            }
            if (this.$bus.scoreEnd.posterContent) {
              const blob = dataURLToBlob(s)
              let fd = new FormData()
              fd.append('file', blob)
              upload(fd).then(res => {
                addLogStory({
                  storyLink: res.data.url,
                  story: this.$bus.scoreEnd.posterContent,
                  answerId: this.$bus.scoreEnd.users[0].answerId,
                  shareAnswerId: this.$bus.scoreEnd.users[1]?.answerId,
                  answerLink: this.$bus.$answerUtil.getShareUrl()
                })
              })
            }
          })
          .catch(err => {
            this.$bus.closeLoading()
            this.genPosterUrlError = true
            this.addErrorLog(err)
          })
    },
    onSwitchAnswer() {
      this.$bus.answerId = this.$bus.scoreEnd.nextAnswerId
      this.$bus.openLoading('正在切换。。。')

      this.$bus.isChangeUserStory = true
      this.$bus.getAnswerRes().then(()=>{
        this.$bus.isChangeUserStory = false
      })
    },
  },
  created() {
    if (this.scoreEnd.users && this.scoreEnd.users.length) {
      this.avatarCount = this.scoreEnd.users.reduce((n, r) => {
        if (r.weixinHeadimgurl) {
          n = n + 1
        }
        return n
      }, 1)
      if (this.scoreEnd.users.length === 1) {
        this.avatarCount++
      }
    } else {
      this.avatarCount = 1
    }

  },
}
</script>

<style scoped lang="scss">
.user-story-wrapper {
  position: relative;


  .poster-wrapper {
    min-height: 600px;
    img {
      display: block;
    }
  }

  .poster-mask {
    position: absolute;
    @apply inset-0 z-20;
  }

  .poster-content {
    position: absolute;
    @apply inset-0 z-10;
  }

  .poster-text-content {
    color: #AF6D33;
    font-size: 14px;
  }

  .poster-info,
  .poster-qrcode,
  .poster-user-list,
  .poster-text-content {
    position: absolute;
  }

  .poster-user-item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 6px 12px;
    background: rgba(247, 248, 215, 0.15);
    border: 2px solid rgba(247, 248, 215, 0.15);
    border-radius: 8px;
    margin-bottom: 8px;
    font-size: 14px;

    img {
      display: block;
    }


    .user-content {
      font-weight: 600;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .yq-btn {
      background-image: linear-gradient(180deg, #FFF9CF 0%, #FFDB7F 100%);
      border-radius: 18px;
      color: rgba(226, 7, 11, 1);
      padding: 0 50px;
      line-height: 32px;
    }
  }

  .switch-btn {
    background-image: linear-gradient(180deg, #FFF9CF 0%, #FFDB7F 100%);
    border-radius: 18px;
    color: rgba(226, 7, 11, 1);
    padding: 0 20px;
    line-height: 32px;

    position: absolute;
    top: 10px;
    right: 10px;
    @apply z-20;
  }
}
</style>